import { Box, Typography } from '@mui/material'
import { ClipLoader } from 'react-spinners'
import * as React from 'react'

interface FlexGridProps {
  children: React.ReactNode[]
  isLoading?: boolean
  isError?: boolean
  currentPage?: number
  pageSize?: number
  totalCount?: number
  showPagination?: boolean
}

const FlexGrid: React.FC<FlexGridProps> = ({
  children,
  isLoading = false,
  isError = false,
  currentPage = 1,
  pageSize = 30,
  totalCount = 0,
  showPagination = true,
}) => {
  const supportEmail = process.env.SUPPORT_EMAIL

  return (
    <Box
      sx={{
        padding: '0 20px',
        marginTop: '20px',
        maxWidth: '1200px',
        margin: '20px auto 0 auto',
      }}
    >
      {children && children.length > 0 && showPagination && (
        <Typography
          sx={{
            marginBottom: '20px',
            color: '#666',
            fontSize: '14px',
          }}
        >
          Viewing {(currentPage - 1) * pageSize + 1}-
          {Math.min(currentPage * pageSize, totalCount)} of {totalCount} items
        </Typography>
      )}

      {isLoading ? (
        <Box
          sx={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}
        >
          <ClipLoader size={30} />
        </Box>
      ) : isError ? (
        <Box sx={{ textAlign: 'center', marginTop: '40px' }}>
          <Typography variant="h6" sx={{ marginBottom: '10px' }}>
            Haven't found what you're looking for?
          </Typography>
          <Typography>
            <a href={`mailto:${supportEmail}`}>Contact Kamba's Sourcing Team</a>{' '}
            for Help
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '16px',
            justifyContent: 'flex-start',
            '& > *': {
              flexShrink: 0,
              flexGrow: 0,
              width: {
                xs: '100%',
                sm: 'calc(50% - 8px)',
                md: 'calc(33.333% - 11px)',
              },
              minWidth: 0,
              boxSizing: 'border-box',
            },
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  )
}

export default FlexGrid
